import { connectSeat } from 'g3d-hm-seat';
class G3DHMGraphics extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.catalog = JSON.parse(this.querySelector('[data-catalog]').textContent);
    this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
    this.forkVariants = JSON.parse(this.querySelector('[data-fork-variants]').textContent);
    this.state = {year:null,graphic:null,rims:null,rimColor:null,spokes:null,spokeColor:null,forks:null,forkBrand:null,forkVariant:null};
    this.form = this.querySelector('form');
    this.querySelectorAll('[data-year]').forEach(button => button.addEventListener('click', () => {
      if (this.state.year !== button.dataset.year) {
        this.state.year = button.dataset.year;
        this.state.graphic = null;
        this.renderCards('graphic', this.catalog.filter(x => x.group === this.state.year));
      }
      this.update();
    }));
    ['rims','spokes'].forEach(kind => this.querySelectorAll('[data-'+kind+']').forEach(button => button.addEventListener('click', () => {
      this.state[kind] = button.dataset[kind] === 'yes';
      if (this.state[kind] && !this.querySelector('[data-'+kind+'-choices]').children.length) {
        this.renderCards(kind,this.catalog.filter(x => x.group === (kind === 'rims' ? 'ADESIVI_CERCHI' : 'COPRI_RAGGI')));
      }
      this.update();
    })));
    this.querySelectorAll('[data-forks]').forEach(button => button.addEventListener('click', () => {
      this.state.forks = button.dataset.forks === 'yes';
      if (this.state.forks) {
        if (!this.state.forkVariant) this.state.forkVariant = this.forkVariants[0] || null;
        if (this.state.forkVariant) this.state.forkBrand = this.state.forkVariant.brand;
        this.renderForkChoices();
      }
      this.update();
    }));
    this.querySelectorAll('[data-fork-brand]').forEach(button => button.addEventListener('click', () => {
      const brand = button.dataset.forkBrand;
      const match = this.forkVariants.find(v => v.brand === brand);
      if (!match) return;
      this.state.forkBrand = brand;
      this.state.forkVariant = match;
      this.renderForkChoices();
      this.update();
    }));
    this.syncSeat = connectSeat(this);
    this.form.addEventListener('submit', event => {
      if (!this.validForPurchase) {event.preventDefault();event.stopImmediatePropagation();return;}
      if (this.validForPurchase) {
        event.preventDefault();event.stopImmediatePropagation();this.addBundle();
      }
    });
    this.update();
  }
  renderCards(kind, entries) {
    const container = this.querySelector('[data-'+kind+'-choices]');
    container.replaceChildren();
    for (const entry of entries) {
      const button = document.createElement('button');button.type = 'button';button.dataset.entry = entry.code;
      button.setAttribute('aria-pressed','false');button.setAttribute('aria-label',entry.name);
      const image = document.createElement('img');
      const thumbnail = new URL(entry.url, window.location.origin);thumbnail.searchParams.set('width','320');
      image.src = thumbnail.href;image.alt = entry.name;image.width = 160;image.height = 160;image.loading = 'lazy';image.decoding = 'async';
      const label = document.createElement('span');label.textContent = kind === 'forks' ? entry.graphic : entry.name;
      button.append(image,label);
      button.addEventListener('click', () => {
        this.state[kind === 'graphic' ? 'graphic' : kind === 'rims' ? 'rimColor' : kind === 'spokes' ? 'spokeColor' : 'forkVariant'] = entry;
        if (kind === 'forks') this.state.forkBrand = entry.brand;
        this.update();
      });
      container.append(button);
    }
  }
  renderForkChoices() {
    const brand = this.state.forkBrand || this.state.forkVariant?.brand || this.forkVariants[0]?.brand;
    if (!brand) return;
    this.state.forkBrand = brand;
    const entries = this.forkVariants.filter(v => v.brand === brand);
    this.renderCards('forks', entries);
    const label = this.querySelector('[data-fork-graphics-label]');
    if (label) label.textContent = entries.length < 2 ? 'Grafica selezionata' : 'Scegli grafica';
  }
  preview(kind, entry, show) {
    const name = kind === 'graphic' ? 'main' : kind;
    const wrapper = this.querySelector('[data-'+name+'-preview]');wrapper.hidden = !show;
    if (!show || !entry) return;
    const image = this.querySelector('[data-'+name+'-image]');
    if (image.getAttribute('src') !== entry.url) image.src = entry.url;
    image.alt = (kind === 'graphic' ? 'Honda HM 50 '+this.state.year+' ' : kind === 'rims' ? 'Adesivi cerchi ' : kind === 'spokes' ? 'Copri raggi ' : 'Adesivi forcelle ') + entry.name;
    this.querySelector('[data-'+name+'-caption]').textContent = kind === 'graphic' ? this.state.year.replace('-', '–')+' · '+entry.name : entry.name;
  }
  formatMoney(cents) {
    return new Intl.NumberFormat('it-IT',{style:'currency',currency:this.dataset.currency || 'EUR'}).format((Number(cents)||0)/100);
  }
  async addBundle() {
    if (this.isAdding || !this.validForPurchase) return;
    this.isAdding = true;
    const button=this.querySelector('[data-buy]');button.disabled=true;
    const note=this.querySelector('[data-price-note]');
    try {
      const mainId=this.form.querySelector('[name=id]').value;
      const properties={};
      this.querySelectorAll('[data-properties] input:not([disabled])').forEach(input=>{
        const match=input.name.match(/^properties\[(.*)\]$/);if(match)properties[match[1]]=input.value;
      });
      const root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
      const items=[{id:Number(mainId),quantity:1,properties}];
      if(this.state.forks&&this.state.forkVariant)items.push({id:Number(this.state.forkVariant.id),quantity:1});
      if(this.seat.active())items.push(this.seat.item());
      const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
      if(!response.ok){const error=await response.json().catch(()=>({}));throw new Error(error.description||'Impossibile aggiungere la configurazione al carrello.');}
      window.location.href=root+'cart';
    } catch(error) {
      this.isAdding=false;button.disabled=false;note.hidden=false;note.textContent=error.message||'Impossibile aggiungere la configurazione al carrello.';
    }
  }
  update() {
    const s = this.state;
    this.syncSeat();
    const rimsComplete = s.rims === false || (s.rims === true && !!s.rimColor);
    const spokesComplete = s.spokes === false || (s.spokes === true && !!s.spokeColor);
    const forksComplete = s.forks === false || (s.forks === true && !!s.forkVariant);
    const complete = !!(s.graphic && rimsComplete && spokesComplete && forksComplete);
    this.querySelector('[data-graphic-step]').hidden = !s.year || !this.catalog.some(x=>x.group===s.year);
    this.querySelector('[data-empty-year]').hidden = !s.year || this.catalog.some(x=>x.group===s.year);
    this.querySelector('[data-rims-step]').hidden = !s.graphic;
    this.querySelector('[data-rims-colors]').hidden = s.rims !== true;
    this.querySelector('[data-spokes-step]').hidden = !s.graphic;
    this.querySelector('[data-spokes-colors]').hidden = s.spokes !== true;
    this.querySelector('[data-forks-step]').hidden = !s.graphic;
    this.querySelector('[data-forks-options]').hidden = s.forks !== true;
    this.querySelector('[data-seat-step]').hidden = !s.graphic;
    this.querySelector('[data-summary]').hidden = !s.graphic;
    this.querySelectorAll('[data-year]').forEach(b => b.setAttribute('aria-pressed',String(b.dataset.year === s.year)));
    for (const kind of ['rims','spokes','forks']) this.querySelectorAll('[data-'+kind+']').forEach(b => b.setAttribute('aria-pressed',String(s[kind] !== null && s[kind] === (b.dataset[kind] === 'yes'))));
    this.querySelectorAll('[data-fork-brand]').forEach(b => b.setAttribute('aria-pressed',String(b.dataset.forkBrand === s.forkBrand)));
    for (const [kind,entry] of [['graphic',s.graphic],['rims',s.rimColor],['spokes',s.spokeColor],['forks',s.forkVariant]]) {
      this.querySelector('[data-'+kind+'-choices]').querySelectorAll('[data-entry]').forEach(b => b.setAttribute('aria-pressed',String(b.dataset.entry === entry?.code)));
      this.preview(kind,entry,kind === 'graphic' ? !!entry : !!entry && s[kind] === true);
    }
    const summary = this.querySelector('[data-summary-values]');summary.replaceChildren();
    const rows = [['Moto',s.year === '2013-2018' ? 'HM Vent 50/125' : 'Honda HM 50'],['Annata',s.year?.replace('-','–') || ''],['Grafica',s.graphic?.name || ''],['Adesivi cerchi',s.rims ? s.rimColor?.name || '' : 'No'],['Copri raggi',s.spokes ? s.spokeColor?.name || '' : 'No'],['Adesivi forcelle',s.forks ? (s.forkVariant ? s.forkVariant.brand+' · '+s.forkVariant.graphic+' · '+s.forkVariant.size : '') : 'No']];
    rows.push(['Coprisella',this.seat.active()?(this.seat.loaded?'Coprisella configurato':'Coprisella da configurare'):'No']);
    for (const [label,value] of rows) {const row=document.createElement('div'),dt=document.createElement('dt'),dd=document.createElement('dd');dt.textContent=label;dd.textContent=value;row.append(dt,dd);summary.append(row);}
    const properties = {'Moto':s.year === '2013-2018' ? 'HM Vent 50/125' : 'HM 50','Annata':s.year?.replace('-','–') || '', 'Grafica':s.graphic?.name || '', 'Codice grafica':s.graphic?.code || '', 'Adesivi cerchi':s.rims ? 'Sì' : 'No', 'Copri raggi':s.spokes ? 'Sì' : 'No', 'Adesivi forcelle':s.forks ? 'Sì' : 'No'};
    if (s.rims && s.rimColor) properties['Colore adesivi cerchi'] = s.rimColor.name;
    if (s.spokes && s.spokeColor) properties['Colore copri raggi'] = s.spokeColor.name;
    if (s.forks && s.forkVariant) properties['Adesivi forcelle scelti'] = s.forkVariant.brand+' · '+s.forkVariant.graphic+' · '+s.forkVariant.size;
    const inputs=this.querySelector('[data-properties]');inputs.replaceChildren();
    for (const [name,value] of Object.entries(properties)) {const input=document.createElement('input');input.type='hidden';input.name='properties['+name+']';input.value=value;input.disabled=!complete;inputs.append(input);}
    const variant = this.variants.find(v => v.group === s.year && v.graphic === s.graphic?.name && v.rims === (s.rims ? 'Sì':'No') && v.spokes === (s.spokes ? 'Sì':'No'));
    const forkAvailable = s.forks !== true || !!s.forkVariant?.available;
    this.validForPurchase = complete && this.seat.complete() && forkAvailable && this.dataset.previewOnly !== 'true' && this.dataset.pricesReady === 'true' && !!variant?.available && variant.price > 0;
    const variantInput=this.form.querySelector('[name=id]');variantInput.value=this.validForPurchase ? variant.id : '';variantInput.disabled=!this.validForPurchase;
    this.querySelector('[data-buy]').disabled=!this.validForPurchase;
    const forkPrice = s.forks && s.forkVariant ? Number(s.forkVariant.price || 0) : 0;
    const seatPrice=this.seat.active()?Number(this.seat.product.price||0):0;
    const extraPrice=forkPrice+seatPrice;
    this.querySelector('[data-price]').textContent=this.dataset.pricesReady === 'true' && variant ? (extraPrice ? this.formatMoney(Number(variant.price)+extraPrice) : variant.formatted) : 'Prezzo da definire';
    const comparison = this.querySelector('[data-compare-price]');
    comparison.hidden = !(this.dataset.pricesReady === 'true' && variant?.compareAt > variant?.price);
    comparison.textContent = comparison.hidden ? '' : (extraPrice ? this.formatMoney(Number(variant.compareAt)+extraPrice) : variant.compareFormatted);
    this.querySelector('[data-price-note]').hidden=this.validForPurchase;
    this.querySelector('[data-price-note]').textContent=this.dataset.pricesReady === 'true' ? (this.dataset.previewOnly === 'true' ? 'Anteprima: prodotto in bozza, acquisto non attivo.' : 'Completa tutte le scelte per aggiungere al carrello.') : 'Prezzi in definizione. Acquisto non ancora disponibile.';
  }
}
if (!customElements.get('g3d-hm-graphics')) customElements.define('g3d-hm-graphics',G3DHMGraphics);



